import { Component } from "react";

interface PageInnerProps {
  children?: React.ReactNode;
  className?: string;
}

export default class PageInner extends Component<PageInnerProps> {
  public render() {
    const classes = `page-inner ${this.props.className || ""}`;

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
}
